import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.gray.gray30,
    },
    link: {
      color: 'inherit',
    },
    contactUsLink: {
      color: COLORS.gray.gray30,
      borderLeft: `1px solid ${COLORS.gray.gray50}`,
      marginLeft: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
  }),
  { name: 'SignUpAgreement' }
);
